import { Image, Text, View } from '@react-pdf/renderer';

import Hexagonal from '@assets/icons/hexagonal.png';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { styles } from '../../styles';
import { stylesAwesome } from '@composites/PDF/AgendaPdfContent/components/EventAtGlance';
import { useTranslation } from 'react-i18next';

interface ContactUsProps {
  event: PublicEventDetailsResponse;
}

const ContactUs = ({ event }: ContactUsProps) => {
  const { t } = useTranslation();

  return (
    <View>
      <View
        style={{
          ...styles.rightSideBody,
          gap: 20,
          alignItems: 'flex-start',
        }}
      >
        <Text style={styles.bodyTitle}>{t('prospectus-title-18')}</Text>
        <Text style={styles.bodyTitle}>{t('prospectus-title-19')}</Text>
        <View style={styles.bodyLineBar} />
      </View>
      <View style={styles.contactUsBody}>
        <View style={styles.contactUsBodyItem}>
          <View style={styles.contactUsBodyHeader}>
            <View>
              <Image style={styles.hexagonal} src={Hexagonal}></Image>
              <View style={styles.whiteIconWrapper}>
                <Text
                  style={{
                    ...stylesAwesome.icon,
                    color: 'white',
                    fontSize: 20,
                  }}
                >
                  {'\uf6ff'}
                </Text>
              </View>
            </View>
            <Text style={styles.contactUsBodyText}>{t('icebreaker')}</Text>
          </View>
          <View style={styles.footerButtonWrapper}>
            <Text
              style={{
                ...styles.footerButton,
                backgroundColor: event?.design.themeColor,
              }}
            >
              {t('get-in-touch')}
            </Text>
          </View>
        </View>
        <View style={styles.contactUsBodyItem}>
          <View style={styles.contactUsBodyHeader}>
            <View>
              <Image style={styles.hexagonal} src={Hexagonal}></Image>
              <View style={styles.whiteIconWrapper}>
                <Text
                  style={{
                    ...stylesAwesome.icon,
                    color: 'white',
                    fontSize: 20,
                  }}
                >
                  {'\uf6ff'}
                </Text>
              </View>
            </View>
            <Text style={styles.contactUsBodyText}>{t('icebreaker')}</Text>
          </View>
          <View style={styles.footerButtonWrapper}>
            <Text
              style={{
                ...styles.footerButton,
                backgroundColor: event?.design.themeColor,
              }}
            >
              {t('get-in-touch')}
            </Text>
          </View>
        </View>
        <View style={styles.contactUsBodyItem}>
          <View style={styles.contactUsBodyHeader}>
            <View>
              <Image style={styles.hexagonal} src={Hexagonal}></Image>
              <View style={styles.whiteIconWrapper}>
                <Text
                  style={{
                    ...stylesAwesome.icon,
                    color: 'white',
                    fontSize: 20,
                  }}
                >
                  {'\uf6ff'}
                </Text>
              </View>
            </View>

            <Text style={styles.contactUsBodyText}>{t('icebreaker')}</Text>
          </View>
          <View style={styles.footerButtonWrapper}>
            <Text
              style={{
                ...styles.footerButton,
                backgroundColor: event?.design.themeColor,
              }}
            >
              {t('get-in-touch')}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default ContactUs;
